// extracted by mini-css-extract-plugin
module.exports = {"bg_about":"About_bg_about__qjv3m","btn_more":"About_btn_more__XLBgh","bg_about_2":"About_bg_about_2___qMCj","bg_about_2_AR":"About_bg_about_2_AR__ywCKM"};